export const MOCK_INTERVIEW_TUTORIAL_STEPS = [
  {
    id: 'mode-selection',
    title: 'Choose Interview Mode',
    description:
      'Select between Guided Interview (structured with stages) or Realistic Interview (open-ended like real interviews). You must choose a mode to continue with the tutorial.',
    placement: 'right',
    image: '/maincar.png',
  },
  {
    id: 'problem-description',
    title: 'Problem Description',
    description:
      'Read through the problem description carefully. Make sure you understand all requirements before starting.',
    placement: 'right',
    image: '/maincar.png',
  },
  {
    id: 'code-editor',
    title: 'Code Editor',
    description:
      'Write your solution here. You can choose from multiple programming languages and the editor supports auto-completion.',
    placement: 'left',
    image: '/thinkingcar.png',
  },
  {
    id: 'interview-panel',
    title: 'AI Interviewer',
    description:
      'Your AI interviewer can simulate a live coding interview! It can see and review your code while guiding you through the problem.',
    placement: 'left',
    image: '/writingcar.png',
  },
];
